/**
 * Signed-in user on the session context — set by the dashboard-configured
 * identity module (side chunk) or the public `l3ns.identify()`.
 */
import { MAX_USER_LEN } from '@l3ns/shared/constants';
import { KEY_USER } from './context';
import { st } from './state';
import { enqueue } from './track';
import { flush } from './transport';

const cap = (v: unknown): string | undefined =>
	v == null ? undefined : String(v).slice(0, MAX_USER_LEN) || undefined;

/**
 * Attach the signed-in user to the live session — or, with no id, detach it
 * (sign-out). Queued events flush FIRST so the sign-in moment splits guest
 * activity from the user's (the login form itself stays a guest's), then a
 * `user_identified` / `user_signed_out` event marks the timeline. The same
 * user again is a no-op. Persisted per tab (sessionStorage) so reloads, SPA
 * routes and the idle session rotation keep the user; nothing is stored
 * without consent.
 */
export function setUser(id?: unknown, name?: unknown): void {
	const s = st.session_;
	if (!s || !st.consent_) return;
	const u = cap(id);
	// a name only ever belongs to the user it came with
	const n = u ? cap(name) || (u == s.uid ? s.uname : undefined) : undefined;
	if (u == s.uid && n == s.uname) return;
	flush('user');
	s.uid = u;
	s.uname = n;
	try {
		sessionStorage.setItem(KEY_USER, JSON.stringify(u ? [u, n] : []));
	} catch {}
	enqueue(u ? 'user_identified' : 'user_signed_out');
}
